module.exports = __webpack_public_path__ + "static/img/02.ff60b3e7.png";